import { LocationQueryValue } from 'vue-router';
import { clientWithoutInterceptors } from '../utils/http';
import DDLogs from '../DDLogs';

export async function isLoggedIn(): Promise<boolean> {
  const response = await clientWithoutInterceptors.get('/api/partial-auth/logged-in/', {
    validateStatus: status => status === 200 || status === 403,
  });
  return response.status === 200;
}

export async function logOut(): Promise<void> {
  await clientWithoutInterceptors.get('/api/logout');
}

export const completeDescopeOtsSignup = async (
  token: string,
  utmParams: any,
  otsParams: any,
  gclid: string | undefined,
  etoroId?: LocationQueryValue | LocationQueryValue[] | undefined,
) => {
  try {
    const resp = await clientWithoutInterceptors.post(
      '/api/no-auth/descope/complete-descope-ots-signup',
      {
        utmParams,
        otsParams,
        etoroId,
        gclid,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return {
      customerId: resp.data.customerId,
      memberId: resp.data.memberId,
      jobId: resp.data.jobId,
    };
  } catch (error) {
    DDLogs.error('Error completing Descope OTS signup:', { error });
    throw error;
  }
};
